import React from 'react';
import { QuoteIcon } from 'lucide-react';
import type { Voice } from '../data/testimonials';
type TestimonialsProps = {
  voices: Voice[];
  title?: string;
  background?: 'white' | 'panel';
};

/**
 * "Teacher voices": frases reales de blogs y FAQs públicos de acro (VOC de
 * la ficha), con fuente. No se presentan como reseñas del producto.
 */
export function Testimonials({
  voices,
  title = 'Sound familiar?',
  background = 'white'
}: TestimonialsProps) {
  if (voices.length === 0) return null;
  const bg = background === 'white' ? 'bg-white' : 'bg-sand-dark';
  return <section aria-label={title} className={`w-full text-night ${bg}`} data-id="element-343" data-mp="2x0tbw3h65ugz">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-344" data-mp="2x2w2aom8hpm8">
        <div className="text-center" data-id="element-345" data-mp="2s2rvjqb4o997">
          <p className="eyebrow text-coral-deep" data-id="element-346" data-mp="2s3tai5v9lfw7">Teacher to teacher</p>
          <h2 className="lane-underline mt-3 font-display text-[30px] leading-tight text-night sm:text-5xl" data-id="element-347" data-mp="v85b00rzzj4d">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-night-soft" data-id="element-348" data-mp="h5y6c818d10g">
            Real words from public acro blogs and FAQs. This is exactly the
            room Acro Yoga Class Ready was built for.
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-349" data-mp="78k01190tslv">
          {voices.map(item => <figure key={item.quote} className="soft-card rounded-3xl border border-sand-dark bg-sand p-6" data-id="element-350" data-mp="c7wry0er1pvb">
              <QuoteIcon className="h-7 w-7 text-coral" aria-hidden="true" data-id="element-351" data-mp="zysf2k89fww8" />
              <blockquote className="field-note mt-2 text-[28px] leading-[1.1] text-night" data-id="element-352" data-mp="14ur50c98lmyr">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-4 text-xs text-night-soft" data-id="element-353" data-mp="v57qfisk4f9p">
                <span className="block text-[13px] font-bold text-night" data-id="element-354" data-mp="v3d3y01n0f3i">
                  {item.author}
                </span>
                {item.source}
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-6 text-center text-[11px] text-night-muted" data-id="element-355" data-mp="1xi91r6l6d9by">
          Quoted as written from public acro blogs and FAQs. Not reviews of
          this product.
        </p>
      </div>
    </section>;
}